import Vue from 'vue'
import Vuex from 'vuex'
import config from '../src/assets/js/config.js'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 定义状态
    state: {
        author: 'Wise Wrong',
        changedata:0,
        listmsgs:[],
        clicks:0,

    },
    mutations:{
        getlist(state, obj){
            var that=this;
            state.changedata=obj.primary;
            // state.listmsgs = obj;
            state.clicks=1;
        }
    },
    actions:{
    //   check({commit, state},datanum) {
    //       console.log(datanum)
    //     axios.get(config.homePage.listmsg)
    //             .then(function (response){
    //             // that.listmsgs=response.data;
    //             commit('getlist', response.data)
    //         })
    //   }
    }
})

export default store



//////////////////
// WEBPACK FOOTER
// ./vuex/store.js
// module id = null
// module chunks = 